const isInElectron = (): boolean =>
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  typeof (window as any).electropaw === 'object'

export default isInElectron
